import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import TableWork from "../../../../ui/datatable/DataTable";
import { BASE_URLS, DOWNLOAD, NO_RECORDS_FOUND, PLATFORM_TYPE } from '../../../../constants/constants'
import {
  useGetElectionScheduleQuery,
  useGetEpbPinUpdatedMutation,
  useGetEpbUnitMutation,
} from '../../../../services/finalizeGenerateViewTransmitService'
import { useDownloadEpbPinMutation } from '../../../../services/epbAndEpbPinService'
import { convertDate, convertDateYMD, parseJwt } from '../../../utilities/utils'
import { ALERT_TYPE_ERROR,ALERT_TYPE_INFO } from '../../../../constants/constants';
import { createAlert } from '../../../../features/alert/alerts'
import moment from 'moment'
import axios from "axios";
import { useDispatch } from "react-redux";
import { showDownloader } from "../../../../features/downloader/downloader";
import { showPercentage } from "../../../../features/downloader/downloader";


const columns = [
  {
    Header: "S. No.",
    accessor: "SNo",
  },
  {
    Header: "State",
    accessor: "State",
  },
  {
    Header: "Phase No",
    accessor: "Phase No",
  },
  {
    Header: "Start Date & Time",
    accessor: "Start Date & Time",
  },
  {
    Header:  "End Date & Time",
    accessor: "End Date & Time",
  },
  {
    Header:   "Cutoff Date & Time",
    accessor: "Cutoff Date & Time",
  },
  {
    Header:   "Total e-PB PIN",
    accessor: "Total e-PB PIN",
  },
  {
    Header:   "Total e-PB PIN Downloaded",
    accessor: "Total e-PB PIN Downloaded",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
  {
    Header: "Last Download Date & Time",
    accessor: "Last Download Date & Time",
  },
 
];

const GeneralElectionToAssemblyConstituency = ({ constType, electType }) => {
  const [filteredData, setfilteredData] = useState('G')
  const [tableData, setTabledata] = useState([])
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [getdata, datap] = useGetEpbUnitMutation()
  const [isUpdated, dataU] = useGetEpbPinUpdatedMutation()
  const dispatch = useDispatch();
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: 'Reject',
      }),
    )
  }
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };
  useEffect(() => {
    getdata({
      electionType: electType,
      constType: constType
    })
  }, [constType, electType, dataU.isSuccess])

  const getballotPin = async (data,stateName) => {
    dispatch(showDownloader({ isdownloading: true }));
    const result = await axios({
      url: `${BASE_URLS.BALLOT_BASE_URL}api/v1/epb-data/download-pin`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.access_token}`,
        currentRole: localStorage.userrole,
        constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0],
        constType: constType,
        atkn_bnd: localStorage?.atkn_bnd,
      rtkn_bnd: localStorage?.rtkn_bnd,
      channelidobo: "ETPBMS",    
      "PLATFORM-TYPE":PLATFORM_TYPE
      },
      data: data,
      responseType: "blob",
      onDownloadProgress: (progressEvent) => {
        console.log(progressEvent,"progressEvent")
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        dispatch(showPercentage({ percentage: percentCompleted }));
      },
    })
      .then((response) => {
        console.log(response,"firstResponse")
        var cd = new Date();
        var currentDate=cd.getFullYear()+"-"+("0"+(cd.getDate())).slice(-2)+"-"+("0"+(cd.getMonth()+1)).slice(-2)+"-"+("0"+cd.getHours()).slice(-2)+("0"+cd.getMinutes()).slice(-2)+("0"+cd.getSeconds()).slice(-2);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `e-PBPIN#${stateName}#${(parseJwt(localStorage?.access_token)?.preferred_username).toUpperCase()}#${constType}#${currentDate}.zip`);
        document.body.appendChild(link);
        link.click();
      })
      .then((response) => {
        console.log(response,"secondResponse")
        setTimeout(() => {
          dispatch(showDownloader({ isdownloading: false }));
          dispatch(showPercentage({ percentage: 0 }));
          isUpdated({
            constType: constType,
            electionType: electType,
            officerId: parseJwt(localStorage.access_token)?.preferred_username,
            stateCd: data?.stateCd,
            statePhaseNo : data?.statePhaseNo,
            currentRole : "unit",
            constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0],
          })
        
        }, 2000);
      }).catch((e)=>{
        dispatch(showDownloader({ isdownloading: false }));
        console.log(e,"exception")
        dispatch(showPercentage({ percentage: 0 }));
        onInfo("Something went wrong Please try again");
      })
  };


  // useEffect(() => {
  //   if (datac.isSuccess) {
  //     const linkSource = window.URL.createObjectURL(datac?.data)
  //     const downloadLink = document.createElement('a')
  //     const fileName = 'ePB-Pin.zip'
  //     downloadLink.href = linkSource
  //     downloadLink.download = fileName
  //     downloadLink.click()
  //   }
  //   getdata({
  //     constType: constType,
  //     electionType: electType,
  //     officerId: parseJwt(localStorage.access_token)?.preferred_username,
  //   })
  // }, [datac.isSuccess])

  const getDate = (date) => {
    var result = date.split('-')
    return new Date(
      parseInt(result[2], 10),
      parseInt(result[1], 10) - 1,
      parseInt(result[0], 10),
    )
  }
  const getDateTime=(date)=>{
    let splittedDateTime=date.split(' ')
    let sDate=splittedDateTime[0].split('-')
    return sDate[2]+'-'+sDate[1]+'-'+sDate[0]+' '+splittedDateTime[1]
  }
  useEffect(() => {
    const epbPinDownloadData = []
    if (datap.isSuccess) {
      datap?.data?.payload?.map((item, i) => {
        let startDate = moment(getDateTime(item.startDateTime)).format(
          'MM-DD-YYYY HH:mm:ss',
        )
        let endDate = moment(getDateTime(item.endDateTime)).format(
          'MM-DD-YYYY HH:mm:ss',
        )
        // let currDate = moment(new Date()).format('MM-DD-YYYY HH:mm:ss');
        let currDate = moment(getDateTime(datap?.data?.serverDateTime)).format('MM-DD-YYYY HH:mm:ss');
        if (currDate <= endDate) {

          epbPinDownloadData.push({
            'SNo': i + 1,
            State: item.stateName,
            'Phase No': item.statePhaseNo,
            'Start Date & Time':  moment(getDateTime(item.startDateTime)).format(
              'DD-MMMM-YYYY HH:mm A',
            ),
            'End Date & Time': moment(getDateTime(item.endDateTime)).format(
              'DD-MMMM-YYYY HH:mm A',
            ),
            'Cutoff Date & Time': moment(getDateTime(item.cutOffDateTime)).format(
              'DD-MMMM-YYYY HH:mm A',
            ),
            'Total e-PB PIN': item.totalCount,
            'Total e-PB PIN Downloaded': item.totalDownLoadedCount,
            Action:
              currDate < startDate ? (
                `The Downloading will start on ${moment(getDateTime(item.startDateTime)).format(
                  'DD-MMMM-YYYY HH:mm A',
                )}`
              ) : (
                <button
                  onClick={() =>
                    getballotPin({
                      electionType: electType,
                      stateCd: item.stateCd,
                      statePhaseNo: item.statePhaseNo,
                      startDate: moment(getDateTime(item.startDateTime)).format(
                        'YYYY-MM-DD HH:mm:ss',
                      ),
                    },item.stateName)
                  }
                >
                  {' '}
                  <i class="fa-solid fa-download mr-2"></i>
                  {DOWNLOAD}
                </button>
              ),
            'Last Download Date & Time': (item.downloadOnTime===""||item.downloadOnTime===null||item.downloadOnTime===undefined)?"Yet to be Downloaded":item.downloadOnTime,
          })
        }
      })
      setTotalNoOfRecords(datap?.data?.payload?.length)
      setTabledata(epbPinDownloadData)
    }
  }, [datap.isSuccess])

  return (
    <>
      {filteredData === 'G' && (
        <TableWork
        placeholder="Search"
        globalsearch={true}
        selectall={true}
        columns={columns}
        emptyMessage="No Record Found"
        data={tableData?.length === 0 ? [] : tableData}
        size={10}
        tableClassNameCheck="contenttable-eroll"
        pagination
        records
        gotopage
        rows
        numberrows={totalNoOfRecords}
      />
      )}
    </>
  )
}

export default GeneralElectionToAssemblyConstituency
